export const DS_KEYBOARD_SHORTCUT_CLASSES = {
  Root: "ds-keyboard-shortcut",
} as const;
